import classNames from 'classnames';
import React from 'react';

const StagingTag = ({ className = '' }) => {
  const { REACT_APP_ENV } = process.env;
  const isStaging = REACT_APP_ENV === 'staging';

  return isStaging ? (
    <div className={classNames('staging-tag', className)}>
      <img src='staging-tag.svg' alt='staging-tag' />
    </div>
  ) : null;
};

export default StagingTag;
